import { Box, Text, Grid } from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { api } from "../../services/api";
import { CityContext } from '../../Context/CityContext';
import { useLocation } from 'react-router-dom';
import { FilterChip } from "../FilterChip";

const drinkTypeOptions = [
  { param: "VODKA GARRAFA", title: "Vodka" },
  { param: "RUM GARRAFA", title: "Rum" },
  { param: "GIN GARRAFA", title: "Gin" },
  { param: "GARRAFA WHISKY", title: "Whisky" },
  { param: "cachaça garrafa", title: "Cachaça" },
  { param: "Licor Garrafa", title: "Licor" },
];
const brandOptions = [
  "Johnnie Walker","Vanfall","Gordon´s","Orloff","Jameson","Seagram's","Jimmy",
  "Malibu","ABSOLUT","Verace","Havana","Wyborowa","BALLANTINES","YB do Brasil",
  "Smirnoff","Bacco","ORLOFF","Sátira","O'Gin","FLOS","Zuur","Beefeater",
  "Jeceaba","Bandarra","Sunflower","Golden Massala",
];

const SectionLabel = ({ children }) => (
  <Text fontSize="11px" fontWeight="800" color="rgba(0,74,51,0.55)" letterSpacing="0.08em" textTransform="uppercase" mb="10px">
    {children}
  </Text>
);

export function HardDrinkFilters(props) {
  const location = useLocation();
  const [drinkTypes, setDrinkTypes] = useState([]);
  const [drinkBrands, setDrinkBrands] = useState([]);
  const { cityParam } = useContext(CityContext);

  async function filterProducts(brands, types) {
    let url = `/api/v1/products?city_id=${cityParam}`;
    if (brands.length > 0) url += `&drink_brands=${brands.join(',')}`;
    if (types.length > 0) url += `&drink_types=${types.join(',')}`;
    if (types.length === 0 && brands.length === 0) {
      const filter = new URLSearchParams(location.search).get("filter");
      if (filter) url += `&filter=${filter}`;
    }
    const response = await api.get(url);
    props.setProducts(response.data.products);
  }

  function toggleType(param) {
    const updated = drinkTypes.includes(param) ? drinkTypes.filter(t => t !== param) : [...drinkTypes, param];
    setDrinkTypes(updated);
    filterProducts(drinkBrands, updated);
  }

  function toggleBrand(brand) {
    const updated = drinkBrands.includes(brand) ? drinkBrands.filter(b => b !== brand) : [...drinkBrands, brand];
    setDrinkBrands(updated);
    filterProducts(updated, drinkTypes);
  }

  return (
    <>
      <SectionLabel>Tipos</SectionLabel>
      <Grid templateColumns="repeat(2,1fr)" gap="8px" mb="20px">
        {drinkTypeOptions.map((t, i) => (
          <FilterChip key={i} label={t.title} isActive={drinkTypes.includes(t.param)} onClick={() => toggleType(t.param)} />
        ))}
      </Grid>

      <Box h="1px" bg="rgba(0,74,51,0.08)" mb="20px" />

      <SectionLabel>Marcas</SectionLabel>
      <Grid templateColumns="repeat(2,1fr)" gap="8px">
        {brandOptions.map((b, i) => (
          <FilterChip key={i} label={b} isActive={drinkBrands.includes(b)} onClick={() => toggleBrand(b)} />
        ))}
      </Grid>
    </>
  );
}
